// Full-width ASCII and punctuation mappings
export const FULLWIDTH_MAP: Record<number, number> = {
  // Full-width space
  12288: 0x8140,
  // Full-width punctuation
  12289: 0x8141, // 、
  12290: 0x8142, // 。
  65292: 0x8143, // ，
  65294: 0x8144, // ．
  12539: 0x8145, // ・
  65306: 0x8146, // ：
  65307: 0x8147, // ；
  65311: 0x8148, // ？
  65281: 0x8149, // ！
  12443: 0x814a, // ゛
  12444: 0x814b, // ゜
  180: 0x814c, // ´
  65344: 0x814d, // ｀
  168: 0x814e, // ¨
  65342: 0x814f, // ＾
  65507: 0x8150, // ￣
  65343: 0x8151, // ＿
  // Brackets
  12308: 0x816b, // 〔
  12309: 0x816c, // 〕
  12304: 0x816d, // 【
  12305: 0x816e, // 】
  12298: 0x8171, // 《
  12299: 0x8172, // 》
  12300: 0x8175, // 「
  12301: 0x8176, // 」
  12302: 0x8177, // 『
  12303: 0x8178, // 』
  65288: 0x8169, // （
  65289: 0x816a, // ）
  65339: 0x816f, // ［
  65341: 0x8170, // ］
  65371: 0x816f, // ｛
  65373: 0x8170, // ｝
  // Symbols
  12291: 0x8156, // 〃
  20189: 0x8157, // 仝
  12293: 0x8158, // 々
  12294: 0x8159, // 〆
  12295: 0x815a, // 〇
  12540: 0x815b, // ー (prolonged sound mark)
  8213: 0x815c, // ―
  8208: 0x815d, // ‐
  65295: 0x815e, // ／
  65340: 0x815f, // ＼
  12316: 0x8160, // 〜
  8214: 0x8161, // ‖
  65372: 0x8162, // ｜
  8230: 0x8163, // …
  8229: 0x8164, // ‥
  8216: 0x8165, // '
  8217: 0x8166, // '
  8220: 0x8167, // "
  8221: 0x8168, // "
  // Math symbols
  65291: 0x817b, // ＋
  65293: 0x817c, // －
  177: 0x817d, // ±
  215: 0x817e, // ×
  247: 0x8180, // ÷
  65309: 0x8181, // ＝
  8800: 0x8182, // ≠
  65308: 0x8183, // ＜
  65310: 0x8184, // ＞
  8806: 0x8185, // ≦
  8807: 0x8186, // ≧
  8734: 0x8187, // ∞
  8756: 0x8188, // ∴
  // Currency and special
  65509: 0x818f, // ￥
  65284: 0x8190, // ＄
  65504: 0x8191, // ￠
  65505: 0x8192, // ￡
  65285: 0x8193, // ％
  65283: 0x8194, // ＃
  65286: 0x8195, // ＆
  65290: 0x8196, // ＊
  65312: 0x8197, // ＠
  // Arrows
  8592: 0x81a9, // ←
  8593: 0x81aa, // ↑
  8594: 0x81a8, // →
  8595: 0x81ab, // ↓
  // Greek letters (common)
  913: 0x839f, // Α
  914: 0x83a0, // Β
  915: 0x83a1, // Γ
  916: 0x83a2, // Δ
  917: 0x83a3, // Ε
  918: 0x83a4, // Ζ
  919: 0x83a5, // Η
  920: 0x83a6, // Θ
  921: 0x83a7, // Ι
  922: 0x83a8, // Κ
  923: 0x83a9, // Λ
  924: 0x83aa, // Μ
  925: 0x83ab, // Ν
  926: 0x83ac, // Ξ
  927: 0x83ad, // Ο
  928: 0x83ae, // Π
  929: 0x83af, // Ρ
  931: 0x83b0, // Σ
  932: 0x83b1, // Τ
  933: 0x83b2, // Υ
  934: 0x83b3, // Φ
  935: 0x83b4, // Χ
  936: 0x83b5, // Ψ
  937: 0x83b6, // Ω
  945: 0x83bf, // α
  946: 0x83c0, // β
  947: 0x83c1, // γ
  948: 0x83c2, // δ
  949: 0x83c3, // ε
  950: 0x83c4, // ζ
  951: 0x83c5, // η
  952: 0x83c6, // θ
  953: 0x83c7, // ι
  954: 0x83c8, // κ
  955: 0x83c9, // λ
  956: 0x83ca, // μ
  957: 0x83cb, // ν
  958: 0x83cc, // ξ
  959: 0x83cd, // ο
  960: 0x83ce, // π
  961: 0x83cf, // ρ
  963: 0x83d0, // σ
  964: 0x83d1, // τ
  965: 0x83d2, // υ
  966: 0x83d3, // φ
  967: 0x83d4, // χ
  968: 0x83d5, // ψ
  969: 0x83d6, // ω
};
